import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["name", "id", "placeholder", "required"]
const _hoisted_2 = {
  key: 0,
  class: "text-input__error-message"
}
const _hoisted_3 = {
  key: 1,
  class: "text-input__error-message"
}

import { PropType, ref } from "vue";
import { IUmbracoFormField } from "@/models/umbraco-forms/IUmbracoFormField";
import { InputState } from "@/models/umbraco-forms/InputState";
import { InputErrorState } from "@/models/umbraco-forms/InputErrorState";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormLongAnswer',
  props: {
  field: {
    type: Object as PropType<IUmbracoFormField>,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const state = ref<InputState>(
  InputState.Pristine | InputState.Invalid | InputState.Untouched | InputState.Empty | InputState.Blurred
);
const errorState = ref<InputErrorState>(InputErrorState.None);
if (props.field?.settings.defaultValue) {
  state.value &= ~InputState.Empty;
}
const onFocus = () => {
  state.value &= ~(InputState.Untouched | InputState.Blurred);
};
const onBlur = (ev) => {
  state.value |= InputState.Blurred;
  checkValidity(ev.target.validity);
};
const onInput = (ev) => {
  state.value &= ~InputState.Pristine;
  if (ev.target.value) {
    state.value &= ~InputState.Empty;
  } else {
    state.value |= InputState.Empty;
  }
};
const onInvalid = (ev) => {
  ev.preventDefault();
  checkValidity(ev.target.validity);
};
const checkValidity = (validity) => {
  errorState.value = InputErrorState.None;
  if (validity.valueMissing) {
    errorState.value |= InputErrorState.Required;
  }
  if (validity.patternMismatch) {
    errorState.value |= InputErrorState.Pattern;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-group", { 'text-input--active': !(state.value & _unref(InputState).Blurred) || !(state.value & _unref(InputState).Empty) }])
  }, [
    _createElementVNode("textarea", {
      class: "form-control",
      name: __props.field.alias,
      id: __props.field.id,
      rows: "3",
      cols: "20",
      placeholder: __props.field.settings.placeholder || __props.field.caption,
      required: __props.field.required,
      onBlur: onBlur,
      onFocus: onFocus,
      onInvalid: onInvalid,
      onInput: onInput
    }, null, 40, _hoisted_1),
    (errorState.value & _unref(InputErrorState).Required)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.field.requiredErrorMessage), 1))
      : _createCommentVNode("", true),
    (errorState.value & _unref(InputErrorState).Pattern)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.field.patternInvalidErrorMessage), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})